module.exports = "/images/Company-Hero.jpg";